// Manages the "account expired" blocked state across the login flow.
//
// Important behavior: this is intentionally in-memory only (module scope),
// not sessionStorage/localStorage. That means:
//   1. We can stop automatic re-login in the current SPA navigation.
//   2. A full page reload clears the block, so another user can login.
//
// The block is also cleared when the user explicitly interacts with the form
// (Next button, federation button), allowing a fresh attempt.

let accountExpiredBlocked = false;

export const ACCOUNT_EXPIRED_ERROR = {
  title: "Your account has expired",
  message: "Please reach out to us at contact.us.engage@toyota.com.",
};

export const setAccountExpiredBlocked = () => {
  accountExpiredBlocked = true;
};

export const isAccountExpiredBlocked = () => {
  return accountExpiredBlocked;
};

export const clearAccountExpiredBlocked = () => {
  accountExpiredBlocked = false;
};
